type CheckedProps = {
  className: string;
  color?: string;
};

export default function Checked(props: CheckedProps) {
  const color = props.color ?? "#003399";
  const className = props.className ?? "";
  return (
    <div className={className}>
      <svg
        style={{ width: "inherit", height: "inherit" }}
        viewBox="0 0 107 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M96.3 0H32.1C26.215 0 21.4 4.815 21.4 10.7V74.9C21.4 80.785 26.215 85.6 32.1 85.6H96.3C102.185 85.6 107 80.785 107 74.9V10.7C107 4.815 102.185 0 96.3 0ZM56.0145 64.2L37.45 45.475L44.94 37.9315L56.0145 49.0595L83.46 21.4L90.95 28.9435L56.0145 64.2ZM10.7 21.4H0V96.3C0 102.185 4.815 107 10.7 107H85.6V96.3H10.7V21.4Z"
          fill={color}
          fillOpacity="0.5"
        />
      </svg>
    </div>
  );
}
